import gql from "graphql-tag";

export const GET_MAIL_TARGETS = gql`
	query getMailTargets($id: String!) {
		mailTargets(documentIdentifier: $id) {
			source, name, email
		}
	}
`;
